import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgTemplateAssertTypeModule } from '@recruitee/common';

import { IconModule } from './../../icon/icon.module';
import { ExperimentalDropdownItemComponent, Variant } from './experimental-dropdown-item.component';

@NgModule({
  declarations: [ExperimentalDropdownItemComponent],
  exports: [ExperimentalDropdownItemComponent],
  imports: [CommonModule, IconModule, NgTemplateAssertTypeModule],
})
export class ExperimentalDropdownItemModule {}

export { Variant };
export { ExperimentalDropdownItemComponent } from './experimental-dropdown-item.component';
